"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castelvetro-di-modena": {
    "8c661ac7": [{
      "hkey": "efae7414",
      "slug": "levizzano-rangone",
      "name": "Levizzano Rangone",
      "primary": true,
      "skipSearch": false
    }],
    "levizzano": [{
      "hkey": "efae7414",
      "slug": "levizzano-rangone",
      "name": "Levizzano Rangone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;